import { createContext } from "react";

import type { OfferDefinition } from "./OfferNode";

/**
 * Resolves the chip text for an offer slug from a live offer list (typically
 * its `getOfferPreview`), or `undefined` when the slug isn't in the list.
 */
export type OfferLabelResolver = (slug: string) => string | undefined;

/**
 * Lets a host that holds a live offer list (e.g. InlineLexicalInput) resolve
 * chip text at render time. Without a provider, `OfferChip` falls back to the
 * label baked into the node at creation — so a chip created before its offer
 * data loaded re-resolves to the offer's preview once the data arrives instead
 * of staying on the `##########` placeholder.
 */
export const OfferLabelContext = createContext<OfferLabelResolver | null>(null);

/**
 * Provides the full offer list to OfferChip so it can render a picker popover
 * when clicked. Without a provider the chip is display-only.
 */
export const OfferListContext = createContext<OfferDefinition[]>([]);
